<template>
  <CmBarCard :value="barInfo"/>
</template>

<script>
import CmBarCard from "@/components/library/statistics/cards/CmHorizontalBar.vue";

export default {
  components: {
    CmBarCard
  },

  props: {
    value: {
      type: Object
    }
  },

  data() {
    return {
      config:  {
        delivered: {
          title: "Доставлено",
          color: "#00AEDF"
        },
        openedTotal: {
          title: "Открыто",
          color: "#FFDA83",
          // hidePercent: true
        },
        opened: {
          title: "Уникальных открыто",
          color: "#FFB341"
        },
        clickedTotal: {
          title: "Переходов",
          color: "rgba(115, 112, 255, 0.6)",
          // hidePercent: true
        },
        clicked: {
          title: "Уникальных переходов",
          color: "#7370FF"
        }
      }
    }
  },

  computed: {
    barInfo() {
      const { MsgStats } = this.value;

      const res = Object.keys(this.config).map(key => {
        return {
          id: key,
          count: this.getCount(MsgStats, key),
          ...this.config[key]
        }
      });

      return res;
    }
  },

  methods: {
    getCount(data, key) {
      if (!data) return 0;
      return data[key] ? data[key].Count : data[key.replace("Total", "")].Total;
    }
  }
}
</script>
